const locations_pt = [
  {
    id: "alverca",
    payment_methods: ["cash", "card"],
    pin: [38.8904648, -9.0399861],
    city: "Alverca",
    location: "Sociedade Filarmónica Recreio Alverquense",
    status: "online",
    address: ["Praça da Sociedade Filarmónica Recreio Alverquense", "2615-391"],
    openingTimes: ["Segunda a Sábado: 10:00 às 19:00"],
    description: "Localizada no coração de Alverca, no distrito de Lisboa, este ATM de Bitcoin encontra-se no interior do café da Sociedade Filarmónica Recreio Alverquense. É uma excelente opção para quem deseja comprar Bitcoin e outras criptomoedas de forma rápida, segura e conveniente com cartão multibanco (débito ou crédito). Com horário de funcionamento alargado e estacionamento gratuito disponível no local, é ideal para utilizadores locais e visitantes.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/32584/bitcoin-atm-general-bytes-alverca-do-ribatejo-sociedade-filarmonica-recreio-alverquense/"
  },
  {
    id: "braga",
    payment_methods: ["cash"],
    pin: [41.5608, -8.3859],
    city: "Braga",
    location: "Centro de Negócios Yah Atlântico",
    status: "online",
    address: [
      "Variante do Fojo - Rua Padre Carmelitas",
      "Edifício Yeah Atlântico, 4719-005"
    ],
    openingTimes: [
      "Segunda a Sexta: 9:00 às 18:00"
    ],
    description: "Localizada no Centro de Negócios Yah Atlântico, em Nogueira – Braga, esta ATM de Bitcoin é uma excelente escolha para profissionais, residentes e turistas a caminho do Bom Jesus do Monte. Situada no átrio do edifício, do lado direito, oferece uma forma rápida e segura de comprar Bitcoin e outras criptomoedas com dinheiro físico. Estacionamento gratuito disponível no local.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/56122/bitcoin-atm-general-bytes-braga-yeah-atlantico/"
  },
  {
    id: "caldas",
    payment_methods: ["cash"],
    pin: [39.4101244, -9.1401931],
    city: "Caldas da Rainha",
    location: "Washstation - Lavandaria Self Service",
    status: "online",
    address: ["R. José Filipe Neto Rebelo 2A", "2500-222 Caldas da Rainha"],
    openingTimes: ["Todos os dias: 07:00 às 21:00"],
    description: "Localizada na lavandaria self-service, esta ATM é uma ótima opção para quem deseja comprar Bitcoin enquanto lava a roupa no distrito de Leiria! Entre no espaço e irá encontrá-la de imediato. Tem horário alargado de funcionamento. Estacionamento gratuito disponível na rua.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/63354/bitcoin-atm-general-bytes-caldas-da-rainha-wash-station-lavandaria/"
  },
  {
    id: "faro",
    payment_methods: ["cash", "card"],
    pin: [37.0288821, -7.945],
    city: "Faro",
    location: "Forum Algarve",
    status: "online",
    address: ["Forum Algarve N125", "8009-020"],
    openingTimes: ["Segunda a Domingo: 10:00 às 23:00"],
    description: "Localizada no centro comercial Forum Algarve em Faro, esta ATM é uma ótima opção para quem deseja comprar Bitcoin enquanto faz compras, tome refeições ou mesmo depois de ir ao cinema! Está localizada ao ar livre, no piso térreo, perto do supermercado Auchan. Estacionamento gratuito disponível no local.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/35267/bitcoin-atm-general-bytes-faro-forum-algarve/"
  },
  {
    id: "funchal",
    payment_methods: ["cash", "card"],
    pin: [32.6513518, -16.905181],
    city: "Funchal",
    location: "IPRO Clinic / Mais Clinic",
    status: "online",
    address: ["Rua João de Deus, 12B", "9050-027 Funchal"],
    openingTimes: ["Segunda a Sábado: 09:00 às 20:00"],
    description: "Quer pagar o seu tratamento dentário com Bitcoin? A Mais Clinic, no Funchal, Madeira, é o lugar ideal! E já que está por lá, porque não aproveitar para comprar criptomoedas na nossa ATM? Toque à campainha e irá encontrá-la imediatamente à sua esquerda.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/79247/bitcoin-atm-general-bytes-funchal-mais-clinic/"
  },
  {
    id: "gaia",
    payment_methods: ["cash", "card"],
    pin: [41.13612084, -8.60850771],
    city: "Gaia",
    location: "Power Dot Charging Station - Jardim do Morro",
    status: "online",
    address: ["Rua Rocha Leão 320", "Gaia, 4430-198"],
    description: "Localizada na estação de carregamento Power Dot, bem no centro de Gaia, esta ATM é uma ótima opção para quem deseja comprar Bitcoin depois de um passeio à beira rio. Está localizada perto da estação de metro de Jardim do Morro. Estacionamento gratuito disponível no local.",
    openingTimes: ["Segunda a Domingo: 09:00 às 20:00"],
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/46528/bitcoin-atm-general-bytes-vila-nova-de-gaia-power-dot-charging-station/"
  },
  {
    id: "lisboa",
    payment_methods: ["cash", "card"],
    pin: [38.72253347583836, -9.133582014684423],
    city: "Lisboa",
    location: "Cotton Club Laundry and Café",
    status: "online",
    address: ["Rua Andrade 15A", "Lisboa, 1170-014"],
    openingTimes: ["Segunda a Domingo: 08:00 às 21:00"],
    description: "Localizado num dos bairros mais coloridos da capital, bem no coração de Lisboa, esta ATM é uma excelente alternativa para quem deseja comprar Bitcoin enquanto lava a roupa ou toma um café com uma nata! Encontra-se no interior da Cotton Club Laundry and Café, do lado esquerdo assim que entra. Procure os autocolantes!",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/45145/bitcoin-atm-general-bytes-lisbon-cotton-club-laundry-and-cafe/"
  },
  {
    id: "maia",
    payment_methods: ["cash", "card"],
    pin: [41.259, -8.641],
    city: "Maia",
    location: "TecMaia",
    status: "online",
    address: [
      "Parque de Ciência e Tecnologia da Maia",
      "Rua Eng.º Frederico Ulrich 2650, 4470-605"
    ],
    description: "Localizada no Parque de Ciência e Tecnologia da Maia, esta ATM é uma ótima opção para quem deseja comprar Bitcoin enquanto trabalha ou visita o complexo empresarial. Está localizada no lobby do edifício principal, ao lado do café e Multibanco. Estacionamento gratuito disponível no local.",
    openingTimes: ["Segunda a Sábado: 10:00 às 19:00"],
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/8962/bitcoin-atm-general-bytes-maia-tecmaia/"
  },
  {
    id: "pinhal-novo",
    payment_methods: ["cash", "card"],
    pin: [38.636369,-8.9140826],
    city: "Pinhal Novo",
    location: "Pinhal Hub",
    status: "online",
    address: [
      "Avenida Alexandre Herculano, 56",
      "2955-112 Pinhal Novo"
    ],
    description: "Localizado no recém-aberto Pinhal Hub, no Pinhal Novo, distrito de Setúbal, esta ATM está mesmo à frente da porta principal — impossível não a ver! Estacionamento gratuito disponível.",
    openingTimes: ["Segunda a Sábado: 10:00 às 20:00"],
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/95615/bitcoin-atm-general-bytes-pinhal-novo-pinhal-hub/"
  },
  {
    id: "porto",
    payment_methods: ["cash"],
    pin: [41.14895102696872, -8.608638369338237],
    city: "Porto",
    location: "French Fries Factory",
    status: "online",
    address: ["Rua do Bonjardim 302 Porto, 4000-115"],
    openingTimes: ["Terça a Sábado: 12:00 às 23:00"],
    description: "Gosta de batatas fritas deliciosas? Gosta de Bitcoin? Então este é o lugar certo para si! Localizada no interior da French Fries Factory, esta ATM é uma excelente opção para quem quer comprar Bitcoin enquanto desfruta de umas saborosas batatas fritas. Está mesmo ao lado da entrada, à esquerda. Bónus: pode pagar pelas suas batatas fritas com Bitcoin!",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/88331/bitcoin-atm-general-bytes-porto-french-fries-factory/"
  }
];

//export default locations_pt;
module.exports = locations_pt;
